import React from 'react';
import { motion } from 'framer-motion';

const SalesLetterWrapper = ({ children, className = "", id = "", alt = false }) => {
  return (
    <section id={id} className={`relative py-12 md:py-24 ${alt ? 'bg-bg-alt' : 'bg-bg-primary'} ${className}`}>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto px-6 text-lg md:text-xl leading-relaxed text-text-primary"
      >
        {children}
      </motion.div>
    </section>
  );
};

export default SalesLetterWrapper;